import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import back from "../../../../store/Vienna_new/65506-200.png";
import room
    from "../../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Executive Double Room - 1550170.jpg";
import suproom
    from "../../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Superior Double Room - 1550188.jpg";
import {React, useEffect, useState} from "react";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";

const Sleep = (props) => {

    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [cards, setCards] = useState([])
    const [, setGroup] = useState(17)
    const [textA, setTextA] = useState([]);
    const [textB, setTextB] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            props.reset();
        }, 2* 60* 1000); // spustí se po 10 vteřinách

        return () => {
            clearTimeout(timer); // vyčisti timeout při unmountu
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const fetchText = async (gr) => {
        try {
            const response = await axios.get(`${path}/getTexts`);
            //console.log(response.data);

            setTextA(response.data[0].text.split("\n"))
            setTextB(response.data[1].text.split("\n"))
            // Optionally, update your UI to reflect the deletion

        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cards]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchDataCards(17)
        fetchText()
    }, [])


    return <>
        <div className={classes.slideshowMenu}>
            <div className={classes.menuBackbt} onClick={() => {
                props.setStep(0)
            }}>
                <img src={back} alt=""/>
            </div>
            <div className={classes.menuLine}>
                <div
                    className={`${classes.buttonCirc} ${classes.sleepBTsubmenu} ${classes.activebt}`}>Sleep
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.eatBTsubmenu}`} onClick={() => {
                    props.setStep(2)
                }}>Eat
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.meetBTsubmenu}`} onClick={() => {
                    props.setStep(3)
                }}>Meet
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.exploreBTsubmenu}`} onClick={() => {
                    props.setStep(4)
                }}>Explore
                </div>
            </div>
            {cards.length > 0 && <img src={cards[currentIndexA].Body.imgURL} alt=""/>}
            {cards.length === 0 && <img src={room} alt=""/>}
        </div>
        <div className={classes.sleepBody}>
            <div className={classes.sleepHeader}>Executive Double Room</div>
            <div className={classes.sleepTxt}>
                <div className={classes.row}>
                    <ul className={classes.list}>
                        {textA.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
                <div className={classes.row}>
                    <ul className={classes.list2}>
                        <li className={classes.lihead}>All room facilities</li>
                        {textB.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className={classes.sleepPic}>
                <img src={suproom} alt=""/>
            </div>
        </div>
    </>
}
export default Sleep;